// Central place for admin-side role rules.
// admin             → full access
// web_management    → website content modules (admissions, notices, events, gallery, results, contact)
// store_management  → operational modules (bus, store/inventory, infrastructure, staff attendance)

export const ROLE_LABELS = {
  admin: "Administrator",
  web_management: "Web Management Staff",
  store_management: "Store Management Staff",
};

// Landing page after login for each role
export const roleHome = (role) => {
  if (role === "admin") return "/admin";
  if (role === "web_management") return "/admin/notices";
  if (role === "store_management") return "/admin/buses";
  return "/"; // unknown/legacy roles go to the public site (avoids redirect loops)
};
